import Action from "../../Classes/Action";
import { actionModalSliceDispatch } from "../../Constants/ReduxConstants";

//Every reducer needs initial state.
const initialState = {
    open: false,
    actionToAdd: new Action()
}

export default function actionModalSlice(state = initialState, action) {
    switch (action.type) {
        case actionModalSliceDispatch.setOpen: {
            return {
                ...state,
                open: action.payload
            }
        }
        case actionModalSliceDispatch.setActionToAdd: {
            return {
                ...state,
                actionToAdd: action.payload
            }
        }
        default:
            return state
    }
}
